import React from "react";
import { motion } from "framer-motion";
import { partners } from "../../constants/siteContent";
import { fadeInUp, staggerContainer } from "../../lib/animations";

export const PartnersSection = () => {
  return (
    <section id="partners" data-testid="partners-section" className="py-24 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer} className="text-center mb-16 md:mb-[4.5rem]">
          <motion.p variants={fadeInUp} className="text-[#D1111A] font-semibold tracking-[0.2em] uppercase mb-3">Working Together</motion.p>
          <motion.h2 variants={fadeInUp} className="font-editorial text-4xl md:text-5xl text-[#0A0A0A] italic">Our Partners</motion.h2>
        </motion.div>

        <motion.div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-7" initial="hidden" whileInView="visible" viewport={{ once: true }} variants={staggerContainer}>
          {partners.map((partner, index) => (
            <motion.a
              key={partner.name}
              href={partner.url}
              target="_blank"
              rel="noopener noreferrer"
              variants={fadeInUp}
              className="group block p-6 md:p-7 bg-[#F4F4F5] border-2 border-transparent hover:border-[#D1111A] hover:bg-white transition-all duration-300 text-center"
              data-testid={`partner-card-${index}`}
            >
              <div className={`mx-auto mb-5 flex min-h-28 items-center justify-center rounded-[1.75rem] border border-[#0A0A0A]/10 p-4 transition-transform duration-300 group-hover:scale-[1.03] ${partner.logoWrapperClassName}`} data-testid={`partner-logo-shell-${index}`}>
                <img src={partner.logo} alt={partner.logoAlt} className={`${partner.logoClassName} object-contain`} loading="lazy" data-testid={`partner-logo-${index}`} />
              </div>
              <h3 className="font-editorial text-lg text-[#0A0A0A] mb-1 group-hover:text-[#D1111A] transition-colors" data-testid={`partner-name-${index}`}>{partner.name}</h3>
              <p className="text-xs text-[#0A0A0A]/60 mb-3" data-testid={`partner-description-${index}`}>{partner.description}</p>
              <span className="inline-flex items-center gap-1 text-[#D1111A] text-xs font-semibold uppercase tracking-wide" data-testid={`partner-visit-label-${index}`}>
                Visit
                <svg className="w-3 h-3 group-hover:translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </span>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};